import "./App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import TreeFelling from "./pages/TreeFelling";
import Landscaping from "./pages/Landscaping";
import WhatsAppButton from "./components/WhatsAppButton";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <HashRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tree-felling" element={<TreeFelling />} />
          <Route path="/landscaping" element={<Landscaping />} />
        </Routes>
        <Footer />
      </HashRouter>
      <WhatsAppButton />
      <Toaster />
    </div>
  );
}

export default App;